import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { formatAmount, formatDate, formatStatus } from "../../../../util/Helpers";

const ViewCampaignModal = ({ showViewCampaignModal, details, onHide }) => {
    return (
        <Modal
            show={showViewCampaignModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    View Campaign Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>CAMPAIGN ID</h6>
                        <span className="text-muted">{details?.campaignId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>DURATION TYPE</h6>
                        <span className="text-muted">{details?.durationType}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>NAME</h6>
                        <span className="text-muted">{details?.name}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>REWARD AMOUNT</h6>
                        <span className="text-muted">{details?.rewardAmount}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Status</h6>
                        <span className="text-muted">{formatStatus(details?.status)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>REWARD CURRENCY</h6>
                        <span className="text-muted">{details?.rewardCurrency}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>TARGET</h6>
                        <span className="text-muted">{details?.target}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>TIMELINE</h6>
                        <span className="text-muted">{details?.timeline}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>TYPE</h6>
                        <span className="text-muted">{details?.type}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>COLOUR CODE</h6>
                        {details?.colorCode ? (
                            <div className="d-flex align-items-center">
                                <span className="text-muted">{details.colorCode}</span>
                                <span
                                    style={{
                                        backgroundColor: details.colorCode,
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "4px",
                                        marginLeft: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                ></span>
                            </div>
                        ) : (
                            <span className="text-muted">NA</span>
                        )}
                    </div>

                    <div className="col-lg py-4">
                        <h6>RECURRING DAYS</h6>
                        <span className="text-muted">
                            {details?.recurrentDays?.length
                                ? details.recurrentDays.map((day) =>
                                    ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][day - 1]
                                ).join(", ")
                                : "NA"}
                        </span>
                    </div>

                    <div className="col-lg py-4">
                        <h6>DESCRIPTION</h6>
                        <span className="text-muted">{details?.description}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>CREATED</h6>
                        <span className="text-muted">{formatDate(details?.created)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>UPDATED</h6>
                        <span className="text-muted">{formatDate(details?.updated)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>START DATE</h6>
                        <span className="text-muted">{formatDate(details?.startDate)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>END DATE</h6>
                        <span className="text-muted">{formatDate(details?.endDate)}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-4"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>

    );
}

export default ViewCampaignModal;